// extracted by mini-css-extract-plugin
export var tosLink = "_47-0";